import { Services } from '@sigma-frontend-libs/commons'
import { EVENTSHISTORY_ASSOCIATED_SERVICES, EVENTSHISTORY_SERVICES, EVENTSHISTORY_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    service() {
      const result = {
        title: this.value.service,
        name: this.value.service,
        single: `${this.value.service}.single`,
        entityId: this.value.data.id,
        createdAt: undefined,
        currentTab: undefined
      }

      switch (this.value.service) {
        case EVENTSHISTORY_SERVICES.recurrentPayments: {
          result.name = Services.payments
          result.single = Services.payments
          result.currentTab = Services.recurrentPayments
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.tasks: {
          result.name = Services.billings
          result.single = Services.billings
          result.currentTab = this.value.service
          result.createdAt = this.getCreatedAt()
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.templates: {
          result.name = 'create'
          result.single = 'create'
          result.currentTab = this.value.service
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.contactLists: {
          result.name = Services.contacts
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.contactListsContacts: {
          result.title = Services.contacts
          result.name = `${Services.contacts}.single`
          result.single = `${Services.contacts}.single`
          result.entityId = this.value?.data?.ListId
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.billingsUsers: {
          result.title = 'billingsUsers'
          result.name = Services.billings
          result.single = Services.billings
          result.currentTab = Services.billings
          result.createdAt = this.getCreatedAt()
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.keywordListsKeywords: {
          result.title = Services.keywords
          result.name = `${Services.keywordLists}.single`
          result.single = `${Services.keywordLists}.single`
          result.entityId = this.value?.data?.ListId
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.permissionsUsers: {
          result.title = 'permissionsUsers'
          result.name = `${Services.users}.single`
          result.single = `${Services.users}.single`
          result.currentTab = Services.permissions
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.settingsUserUsers: {
          const [ settingKey ] = this.value?.data?.new?.field?.split('.') || []
          result.title = 'settingsUserUsers'
          result.name = `${Services.users}.single`
          result.single = `${Services.users}.single`
          result.currentTab = Services.settingsUser
          result.settingKey = settingKey
          result.entityId = this.value?.entityId
          break
        }
        case EVENTSHISTORY_ASSOCIATED_SERVICES.tokensUsers: {
          result.title = Services.tokens
          result.name = `${Services.users}.single`
          result.single = `${Services.users}.single`
          result.currentTab = Services.tokens
          result.entityId = this.value?.entityId
          break
        }
      }

      return result
    },

    toParamsForServiceSticker() {
      switch (this.value.service) {
        case EVENTSHISTORY_ASSOCIATED_SERVICES.contactListsContacts:
        case EVENTSHISTORY_ASSOCIATED_SERVICES.keywordListsKeywords:
        case EVENTSHISTORY_ASSOCIATED_SERVICES.settingsUserUsers:
        case EVENTSHISTORY_ASSOCIATED_SERVICES.tokensUsers: return { id: this.service.entityId }
        default: return undefined
      }
    },

    computedTo() {
      if (EVENTSHISTORY_TYPES[this.value.type] !== 'removed') {
        return {
          name: this.service.single,
          params: {
            id: this.service.entityId,
            createdAt: this.service.createdAt
          },
          query: {
            currentTab: this.service.currentTab,
            settingKey: this.service.settingKey
          }
        }
      }
    }
  },

  methods: {
    getCreatedAt() {
      const gt = this.value.data.createdAt
      const lt = new Date(gt).setSeconds(new Date(gt).getSeconds() + 1)

      return {
        $gt: gt,
        $lt: new Date(lt).toISOString()
      }
    }
  },

  render
}
